import { Collapse, InputNumber, Select } from "antd";
import { useSelector } from "react-redux";

const { Panel } = Collapse;
const { Option } = Select;

const FabricCollapase = ({
  index,
  ft,
  genExtra,
  setProductToUpdate,
  productToUpdate,
  setData,
  data,
  options,
  handleChangeFabric,
}: any) => {
  const { user } = useSelector((state: any) => state.auth);
  function comparer(otherArray: any) {
    return function (current: any) {
      return (
        otherArray.filter(function (other: any) {
          return other.id == current.id;
        }).length == 0
      );
    };
  }
  return (
    <Collapse defaultActiveKey={["0"]} key={index + 2}>
      <Panel
        header={ft.name || `Fabric type num ${index + 1}`}
        key={index}
        extra={genExtra(index)}
      >
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <th>Type of fabric</th>
              <td>
                <Select
                  disabled={
                    !user.permissions.includes("product.fabric.management") &&
                    !user.permissions.includes("product.update")
                  }
                  value={ft.name}
                  style={{ width: "100%" }}
                  placeholder="Select Type of Fabric"
                  onChange={(val: any) => {
                    setProductToUpdate({
                      ...productToUpdate,
                      fabric_types: productToUpdate.fabric_types.map(
                        (f_types: any) =>
                          f_types.id === ft.id ? JSON.parse(val) : f_types
                      ),
                    });
                    setData({
                      ...data,
                      fabric_types: data.fabric_types.map((f_types: any) =>
                        f_types.fabric_type_id === ft.id
                          ? {
                              ...f_types,
                              fabric_type_id: JSON.parse(val).id,
                            }
                          : f_types
                      ),
                    });
                  }}
                >
                  {options.fabric_types_options &&
                    options.fabric_types_options
                      .filter(comparer(productToUpdate.fabric_types))
                      .map((el: any) => (
                        <Option value={JSON.stringify(el)} key={el.id}>
                          {el.name}
                        </Option>
                      ))}
                </Select>
              </td>
            </tr>
            <tr>
              <th>Weight</th>
              <td>
                <InputNumber
                  disabled={
                    !user.permissions.includes("product.fabric.management") &&
                    !user.permissions.includes("product.update")
                  }
                  style={{ width: "100%" }}
                  min={0}
                  defaultValue={ft.weight}
                  name="weight"
                  onChange={(num: number) =>
                    handleChangeFabric(num, "weight", ft.id)
                  }
                />
              </td>
            </tr>
            <tr>
              <th>BCI Cotton Price</th>
              <td>
                <InputNumber
                  disabled={
                    !user.permissions.includes("product.fabric.management") &&
                    !user.permissions.includes("product.update")
                  }
                  style={{ width: "100%" }}
                  min={0}
                  defaultValue={ft.price}
                  name="price"
                  onChange={(num: number) =>
                    handleChangeFabric(num, "price", ft.id)
                  }
                />
              </td>
            </tr>
            <tr>
              <th>Organic Cotton Price</th>
              <td>
                <InputNumber
                  disabled={
                    !user.permissions.includes("product.fabric.management") &&
                    !user.permissions.includes("product.update")
                  }
                  style={{ width: "100%" }}
                  min={0}
                  defaultValue={ft.price_two}
                  name="price_two"
                  onChange={(num: number) =>
                    handleChangeFabric(num, "price_two", ft.id)
                  }
                />
              </td>
            </tr>

            <tr>
              <th>Price</th>
              <td>
                <InputNumber
                  disabled={
                    !user.permissions.includes("product.fabric.management") &&
                    !user.permissions.includes("product.update")
                  }
                  style={{ width: "100%" }}
                  min={0}
                  defaultValue={ft.total_price}
                  name="total_price"
                  onChange={(num: number) =>
                    handleChangeFabric(num, "total_price", ft.id)
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </Panel>
    </Collapse>
  );
};

export default FabricCollapase;
